<template>
  <span class="languages">
    <v-checkbox
      id="announcement-language-cz"
      v-model="selectedLanguages"
      :value="cz"
      @update:modelValue="onChange('cz')"
      class="mr-7"
      label="čeština"
      hide-details
      color="#78BE13"
    >
    </v-checkbox>
    <v-checkbox
      v-model="selectedLanguages"
      id="announcement-language-en"
      :value="en"
      @update:modelValue="onChange('en')"
      label="angličtina"
      hide-details
      color="#78BE13"
    >
    </v-checkbox>
  </span>
</template>

<script setup>
import {ref} from 'vue';

  const props = defineProps({
    /**
     * Initial languages selection.
     */
    initialValues: Array,
  });

  const cz = 'cz';
  const en = 'en';

  const selectedLanguages = ref([...props.initialValues]);

  const emit = defineEmits(['change']);

  const onChange = (language) => {
    if (selectedLanguages.value.length === 0) {
      selectedLanguages.value = language === en ? [cz] : [en]
    }
    selectedLanguages.value.sort();
    emit("change", selectedLanguages.value);
  };
</script>

<style scoped>
  .languages {
    display: inherit;
  }
</style>
